export default "__VITE_ASSET__d991bPQg__"